import { ChangeDetectorRef, Component, OnChanges, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { downloadCsv, yearsList } from 'src/app/core/utils/utils';
import { IFinantialReceiptsReport } from 'src/app/shared/interfaces/finantial-receipts-report/ifinantial-receipts-report';
import { ModalService } from 'src/app/shared/services/modal.service';
import { finantialReceiptsReportActions } from 'src/app/store/finantial-receipts-report/finantial-receipts-report.actions';
import { selectFinantialReceiptsReport } from 'src/app/store/finantial-receipts-report/finantial-receipts-report.selectors';
import { SearchExpensesComponent } from '../search-expenses/search-expenses.component';
import { SearchReceiptsComponent } from '../search-receipts/search-receipts.component';
import { selectUnitActiveList } from 'src/app/store/unidade/unidade.selectors';
import { FinantialReceiptsReportService } from 'src/app/shared/services/finantial-receipts-report.service';
import { IFilterModel } from 'src/app/shared/models/filter-model';
import { Filter } from 'src/app/shared/models/filter';
import { ReceitaPesquisaComponent } from '../../financeiro/receita/receita-pesquisa/receita-pesquisa.component';


@Component({
  selector: 'app-finantial-receipts-report',
  templateUrl: './finantial-receipts-report.component.html',
  styleUrls: ['./finantial-receipts-report.component.scss']
})
export class FinantialReceiptsReportComponent {

  filterYearToYearGraphic = new Filter();
  filterAnnualRevenue = new Filter();
  filterMonthToMonth = new Filter();
  filterReportTypesOfRevenue = new Filter();
  filterAnnualResultsFinancial = new Filter();
  currentUnit = localStorage.getItem('unitId')

  monthToMonthData: any = {
    current: 0,
    previous: 0,
    labels: [],
    data: [],
    graphic: {}
  };

  yearToYearData: any = {
    current: 0,
    columns: [],
    data: [],
  }

  graphAnual: any;

  graphRevenueYear: any[] = []

  receiptMonthly: any;

  graphReportTypesOfRevenue: any = {}


  constructor(
    private modalService: ModalService,
    private finantialReceiptsReportService: FinantialReceiptsReportService
    ) {
  }
  openModalReceitas() {
    this.modalService.calledfor("Search Receipts Dialog");
    this.modalService.show(ReceitaPesquisaComponent, "Pesquisar Receita");
  }
  
  ngOnInit(): void {
    this.filterAnnualRevenue.filter("unit", this.currentUnit as string, "IN");
    //this.loadAnnualRevenueGraphic();
    this.loadYearToYearGraphic();
    this.loadResultsMonthlyMovment();

    this.filterMonthToMonth
        .filter("unit", this.currentUnit as string, "IN")
        .filter("year", 2024, "AND")
    this.loadMonthToMonth();


    this.filterReportTypesOfRevenue.filter("unit", this.currentUnit as string, "IN")
                            .filter("year", 2024, "AND")
    this.loadReportTypesOfRevenue();
   
    this.filterAnnualResultsFinancial.filter("unit", this.currentUnit as string, "IN")
    this.loadAnnualResultsFinancial();

  }

  ngOnDestroy() {
  }
 

  loadResultsMonthlyMovment() {
    let filter = new Filter().filter("unit", 174, "IN").filter("year", 2024, "AND").convertFilterInQuery();
    this.finantialReceiptsReportService.getResultMonthlyFinantial(filter).subscribe((response: any) => {
      console.log(response);
      this.receiptMonthly = [];
      response.forEach((item : any) => {
        let columns = [];
        columns.push({
          valor: item.data['total_revenue'],
          descricao: 'Rec. total'
        });
        columns.push({
          valor: item.data['company_revenue'],
          descricao: 'Rec. empresa Liquida'
        });
        columns.push({
          valor: item.data['expense'],
          descricao: 'despesas'
        });
        columns.push({
          valor: item.data['result'],
          descricao: 'resultado liquido'
        });

        this.receiptMonthly.push({
          percentage: item.comparative,
          data: item.period,
          columns: columns
        });
      })
    });
  }






  onFilterYearToYear(event: IFilterModel[]) {
    event.forEach(e => {
      this.filterYearToYearGraphic.setFilter(e.key, e.filter);
    });

    this.loadYearToYearGraphic(this.filterYearToYearGraphic.convertFilterInQuery())
    
  }

  onFilterMonthToMonth(event: IFilterModel[]) {
    event.forEach(e => {
      this.filterMonthToMonth.setFilter(e.key, e.filter);
    });

    this.loadMonthToMonth(); 
  }
  
  onFilterAnnualRevenue(event: IFilterModel[]) {
    event.forEach(e => {
      this.filterAnnualResultsFinancial.setFilter(e.key, e.filter);
    });

    this.loadAnnualResultsFinancial(); 
  }

  loadMonthToMonth() {
    let filter = this.filterMonthToMonth.convertFilterInQuery();
    this.finantialReceiptsReportService.getMonthToMonth(filter).subscribe(
      (res: any) => {
        this.monthToMonthData = res;
        this.monthToMonthData.labels = Object.keys(res.graphic);
        this.monthToMonthData.data = [{
          gradientColors: ['rgba(0, 160, 0, 1)', 'rgba(255, 255, 255, 0)'],
          data: Object.values(res.graphic),
          legend: 'Receitas'
        }];
      }
     );
  }

  loadAnnualResultsFinancial() {
    let filter = this.filterAnnualResultsFinancial.convertFilterInQuery();
    this.finantialReceiptsReportService
        .getAnnualResultsFinancial(filter)
        .subscribe(
          (response: any) => {
            this.graphAnual = Object.keys(response.graphic).map((key) => {return {ano: key , value: response.graphic[key]}});
          }
        )
  }

  loadReportTypesOfRevenue() {
    let filter = this.filterReportTypesOfRevenue.convertFilterInQuery();
    this.finantialReceiptsReportService
    .getReportTypesOfRevenue(filter)
    .subscribe(
      (response: any) => {

        let {appointments, exams, others, procedures} = response.graphic;
        this.graphReportTypesOfRevenue.labels = Object.keys(appointments);
        this.graphReportTypesOfRevenue.data = [
          {
            gradientColors: ['#004AA0', 'rgba(255, 255, 255, 0)'],
            data: Object.values(appointments),
            legend: 'Atendimentos'
          },
          {
            gradientColors: ['#00A000', 'rgba(255, 255, 255, 0)'],
            data: Object.values(procedures),
            legend: 'Procedimentos'
          },
          {
            gradientColors: ['#DB0000', 'rgba(255, 255, 255, 0)'],
            data: Object.values(exams),
            legend: 'Exames'
          },
          {
            gradientColors: ['#FF8321', 'rgba(255, 255, 255, 0)'],
            data: Object.values(others),
            legend: 'Outros'
          }
        ]

      }
    );
  }

 /* loadAnnualRevenueGraphic(){
    let filter = this.filterAnnualRevenue.convertFilterInQuery();
    this.finantialReceiptsReportService.getRevenueYear(filter).subscribe(
      (res: any) => {
        console.log(res);
       this.graphRevenueYear = Object.keys(res.graphic).map((key) => {
         return {
           year: key,
           value: [{valor: res[key].value.toFixed(2), descricao: "lucro"}],
           percentage: res[key].percentual,
           label: 'Faturamento total'
         }
       });
       console.log(this.graphRevenueYear)
      }
     )
  }*/

  loadYearToYearGraphic(filter: string = ''){

    this.finantialReceiptsReportService.getYearToYear(filter).subscribe(
      (res: any) => {
        this.yearToYearData.current = res.currentYear.profit;
        this.yearToYearData.columns = Object.keys(res.graphic)
        this.yearToYearData.data = Object.values(res.graphic)
  
      }
     );

  }

  downloadAnnualRevenue(){
    let filter = this.filterAnnualRevenue.convertFilterInQuery()

    if(filter == ''){
      filter = `?unit[]=${this.currentUnit}`
    }
    
    filter = filter + '&csv=true'

    this.finantialReceiptsReportService.getRevenueYear(filter).subscribe(csv => {
      downloadCsv("data:text/csv;charset=utf-8,"+csv,'annual_revenue');
    })


  }
}
